import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export const initSentry = () => {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [new BrowserTracing()],
      
      // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
      // In production, you'll want to adjust this value to optimize performance vs. data collection
      tracesSampleRate: 0.5,
      
      // Capture errors based on environment
      environment: import.meta.env.MODE,
      
      // Only capture errors in production
      enabled: import.meta.env.PROD,
      
      // Don't capture errors from localhost or development environments
      beforeSend(event) {
        // Check if we're in a development environment or localhost
        if (window.location.hostname === 'localhost' || 
            window.location.hostname === '127.0.0.1' ||
            import.meta.env.DEV) {
          return null;
        }
        return event;
      }
    });
  }
};

// Helper to capture exceptions with user context
export const captureException = (error: any, context?: Record<string, any>) => {
  if (context) {
    Sentry.withScope((scope) => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
};

// Set user information once they're authenticated
export const setUserContext = (user: { id: string; email?: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email
  });
};

// Clear user context on logout
export const clearUserContext = () => {
  Sentry.setUser(null);
};
